import { render, staticRenderFns } from "./SmsChat.vue?vue&type=template&id=acca6c96&scoped=true&"
import script from "./SmsChat.vue?vue&type=script&lang=js&"
export * from "./SmsChat.vue?vue&type=script&lang=js&"
import style0 from "./SmsChat.vue?vue&type=style&index=0&id=acca6c96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acca6c96",
  null
  
)

export default component.exports